export class AuthorizationModel {
  permission: string;
  permissions: string[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/permission/models/authorize.model.ts